export default {
  stepPrepare: "Zahlung vorbereiten",
  stepProcess: "Zahlung verarbeiten",
  stepConfirm: "Bestellung bestätigen",
  preparing: "Zahlungsumgebung wird vorbereitet",
  confirmingPayment: "Zahlung wird bestätigt",
  confirmingOrder: "Bestellung wird bestätigt",
  possibleIssue: "Mögliches Problem erkannt",
  settingUp: "Sichere Zahlung wird eingerichtet…",
  waitingConfirmation: "Warten auf Transaktionsbestätigung…",
  updatingAccount: "Kontoinformationen werden aktualisiert…",
  paymentSuccessful: "Zahlung erfolgreich!",
  upgradeSuccess: "Ihr Plan wurde erfolgreich aktualisiert.",
  continue: "Weiter",
  somethingWentWrong: "Bei Ihrer Zahlung ist etwas schiefgelaufen.",
  tryAgain: "Erneut versuchen",
  paymentCancelled: "Zahlung storniert",
  cancelledTransaction: "Sie haben das Zahlungsfenster geschlossen oder die Transaktion storniert.",
  timeoutMessage:
    "Möglicherweise ist ein Problem aufgetreten. Sie können prüfen, ob Ihre Vorteile wirksam geworden sind. Wenn Sie Hilfe benötigen, wenden Sie sich bitte an unseren Support unter {supportEmail}.",
  secureEncrypted: "Ihre Bankdaten sind sicher verschlüsselt",
  havingTrouble: "Probleme? Kontaktieren Sie {supportEmail}",
};
